/**
 * Technology partners used by the homepage and the presence map.
 * Headquarters feed the About map. End users (Ford, Lucid) live in data/endUsers.js.
 */
export const partners = [
  {
    name: "ABB",
    slug: "abb",
    logo: "/abb.png",
    headquarters: {
      city: "Zurich",
      country: "Switzerland",
      lat: 47.3769,
      lng: 8.5417,
    },
  },
  {
    name: "VisionNav",
    slug: "visionnav",
    logo: "/visionnav.png",
    headquarters: {
      city: "Shenzhen",
      country: "China",
      lat: 22.5431,
      lng: 114.0579,
    },
  },
  {
    name: "SYNAOS",
    slug: "synaos",
    logo: "/synaos.svg",
    headquarters: {
      city: "Hanover",
      country: "Germany",
      lat: 52.3759,
      lng: 9.732,
    },
  },
  {
    name: "BluePath Robotics",
    slug: "bluepath",
    logo: "/bluepath.png",
    headquarters: {
      city: "Istanbul",
      country: "Turkey",
      lat: 40.8784,
      lng: 29.2684,
    },
  },
  {
    name: "KUKA",
    slug: "kuka",
    logo: "/vendor-partner-logos/kuka-logo.png",
  },
  {
    name: "OTTO by Rockwell Automation",
    slug: "otto",
    logo: "/vendor-partner-logos/otto-rockwell-logo.png",
  },
  {
    name: "SEER Robotics",
    slug: "seer",
    logo: "/vendor-partner-logos/seer-robotics-logo.png",
  },
  {
    name: "wheel.me",
    slug: "wheelme",
    logo: "/vendor-partner-logos/wheelme-logo.png",
  },
];
